<div
  class="alert d-flex justify-content-between align-items-center h-100 mb-0 alert-danger gap-1"
  [ngClass]="'alert-' + type"
  role="alert"
>
  <div class="d-flex align-items-center gap-2">
    <span class="icon-alert"></span>
    <span>{{ messageKey | translate:{count: count} }}</span>
  </div>
  <button class="btn btn-primary px-3" [routerLink]="url" [queryParams]="queryParams">
    {{ buttonKey | translate }}
  </button>
</div>
